import { useState } from "react";
import NestedCarouselBaseItem from "../NestedCarouselBaseItem/NestedCarouselBaseItem";
import styles from "./NestedCarouselItem.module.scss";
import { DialogWithExit } from "@/src/component/base/DialogWithExit";
import TextModule from "../../component/TextModule/TextModule";

interface NestedCarouselItemProps {
  item: any;
  childItems?: any[];
  lazy?: "lazy" | "eager";
  quality?: number;
}

function NestedCarouselItem({ item, childItems, lazy, quality }: NestedCarouselItemProps) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleItemClick = (ctaClick?: () => void) => {
    if (childItems?.length) {
      setIsModalVisible(true);
      return;
    }

    ctaClick?.();
  };

  return (
    <>
      <NestedCarouselBaseItem
        onClick={handleItemClick}
        item={item}
        lazy={lazy}
        quality={quality}
      />
      {isModalVisible ? (
        <DialogWithExit
          dialogProps={{
            open: isModalVisible,
            PaperProps: {
              className: styles.carouselDialogPaper,
            },
          }}
          dialogContentProps={{
            className: styles.carouselDialogContent,
          }}
          onExit={() => setIsModalVisible(false)}
        >
          <div>
            <TextModule
              text={{
                tag: "body1",
                text: item.cardDialogTitle ?? `${item.title} in Flow`,
              }}
              className={styles.carouselChildTitle}
            />
            <TextModule
              text={{
                tag: "body1",
                text: item.cardDialogSubtitle ?? `${item.title} in a Flow community`,
              }}
              className={styles.carouselChildSubtitle}
            />
            <div className={styles.carouselChildItems}>
              {childItems?.map((item) => (
                <NestedCarouselBaseItem
                  key={item.id}
                  item={item}
                  isOutline={true}
                  lazy={lazy}
                  quality={quality}
                />
              ))}
            </div>
          </div>
        </DialogWithExit>
      ) : null}
    </>
  );
}

export default NestedCarouselItem;
